<template>
  <div class="flex items-center w-full">
    <div class="flex items-center w-full">
      <feather-icon v-if="done" icon="CheckSquareIcon" class="w-5 mr-2 cursor-pointer" @click="toggleDone(!done)" />
      <feather-icon v-else icon="SquareIcon" class="w-5 mr-2 cursor-pointer" @click="toggleDone(!done)" />

      <vs-input v-if="editing" autofocus class="inputx skeleton-input" ref="skeleton_input_edit" @keyup.enter.native="save" @focusout="save" v-model="subtask.title" />
      <p v-else :class="done ? 'text-muted line-through' : ''">{{subtask.title}}</p>
    </div>
    <div class="flex justify-end ml-2">
      <feather-icon icon="EditIcon" class="w-4 cursor-pointer flex justify-end" @click.prevent="editing=true" />
      <feather-icon icon="TrashIcon" class="w-4 cursor-pointer flex justify-end" @click="$emit('destroySubtask', subtask)" />
    </div>

  </div>
</template>

<script>

export default {
  components: {
    // DoubleClick,
  },
  data () {
    return {
      editing: false,
    }
  },
  props: {
    subtask: {
      type: Object,
      required: true,
    },
  },
  computed: {
    done () { return this.subtask.done }
  },
  watch: {
    'editing': {
      immediate: false,
      handler (editing) {
        if (editing) {
          this.$forceNextTick(() => this.$refs['skeleton_input_edit'].focusInput())
        }
      }
    }
  },
  methods: {
    save () {
      this.editing = false
    },
    toggleDone (done) {
      this.subtask.done = done

      if (done) {
        this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada')
      }
    },
  }
}
</script>
